/* assets/sale-popup.js — updated timings */
(function () {
  var root = document.getElementById('sw-bl-popup');
  if (!root) return;

  var duration = 13226; // 🔥 3 hours 40 minutes 26 seconds
  var dismissHours = 1;
  var storageKey = 'site_sale_popup_dismiss_v1';

  // UPDATED TIMERS
  var FIRST_SHOW_DELAY = 30;   // first show after 30 sec
  var REPEAT_INTERVAL = 40;    // show every 40 sec
  var VISIBLE_DURATION = 6;    // visible for 6 sec

  var countEl = document.getElementById('sw-bl-count');
  var closeBtn = document.getElementById('sw-bl-close');

  // Respect prior dismissal
  try {
    var dismissedAt = Number(localStorage.getItem(storageKey) || 0);
    if (dismissedAt && (Date.now() - dismissedAt) < (dismissHours * 3600 * 1000)) {
      return;
    }
  } catch (e) {}

  // Countdown
  var remaining = duration;

  function fmt(t) {
    var hrs = Math.floor(t / 3600);
    var mins = Math.floor((t % 3600) / 60);
    var secs = Math.floor(t % 60);
    return (
      String(hrs).padStart(2, '0') + ':' +
      String(mins).padStart(2, '0') + ':' +
      String(secs).padStart(2, '0')
    );
  }

  countEl.textContent = fmt(remaining);

  var countdown = setInterval(function () {
    remaining--;
    if (remaining <= 0) {
      remaining = 0;
      countEl.textContent = "00:00:00";
      clearInterval(countdown);
      return;
    }
    countEl.textContent = fmt(remaining);
  }, 1000);

  // SHOW POPUP (with auto-hide)
  function showPopup() {
    root.classList.add('show');
    setTimeout(function () {
      root.classList.remove('show');
    }, VISIBLE_DURATION * 1000);
  }

  // FIRST SHOW after 30 sec
  setTimeout(function () {
    showPopup();

    // repeat every 40 sec
    setInterval(showPopup, REPEAT_INTERVAL * 1000);

  }, FIRST_SHOW_DELAY * 1000);

  // Close button behavior
  closeBtn.addEventListener('click', function () {
    root.classList.remove('show');
    localStorage.setItem(storageKey, String(Date.now()));
    clearInterval(countdown);
  });

})();
